import { BizyState } from '../../bizy';

interface DraftAssistBizyStateOptions {
	isLoading: boolean;
	isScoring?: boolean;
	isOpen: boolean;
}

export const getDraftAssistBizyState = ({ isLoading, isScoring, isOpen }: DraftAssistBizyStateOptions): BizyState => {
	if (isLoading || isScoring) return 'thinking';
	return isOpen ? 'pointingRight' : 'curious';
};
